<template>
  <div>
    <div style="padding: 0px 10px 15px 10px">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="left"
        label-width="80px"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_locationNo') || '库位号'"
              prop="locationCode"
            >
              <el-cascader
                :options="treeData"
                :props="{
                  emitPath: false,
                  checkStrictly: true,
                  value: 'code',
                  label: 'label',
                }"
                size="small"
                ref="cascaderFunctionTreeRef"
                v-model="form.locationCode"
                @change="calculateClassLevel"
                filterable
                clearable
                style="width: 100%"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <span v-if="!node.isLeaf">
                    ({{ data.children.length }})
                  </span>
                </template>
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_sampleBarcode') || '样品条码'"
              prop="sampleBarcode"
            >
              <el-input
                v-model="form.sampleBarcode"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="50"
                clearable
                size="small"
                style="width: 100%"
                @change="getSampleInfo"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <SampleTable :tableData="tableData" @delRow="delRow"></SampleTable>

    <div class="d-flex justify-content-end mt-2 mb-2">
      <el-button type="primary" size="small" @click="shelve()">
        {{ $l('btn_shelve') || '上架' }}
      </el-button>
    </div>
  </div>
</template>
<script>
import SampleTable from './sample-table'
import validate from '@/libs/util.validate'
export default {
  components: { SampleTable },
  props: {
    treeData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tableData: [],
      form: {
        locationNo: '',
        locationCode: '',
        level: 0,
        sampleBarcode: '',
      },
      rules: {
        locationCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    sampleBarcodeList() {
      return this.tableData.map((e) => e.sampleBarcode)
    },
  },
  methods: {
    cancel() {
      this.$emit('close')
    },
    async shelve() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      if (this.form.level == '0') {
        this.$message.warning(
          this.$l('dialog_confirm_msg') || '不可将顶级展厅设置为库位！'
        )
        return
      }
      this.$api
        .stockSampleLocationChangeLocationApi({
          locationNo: this.form.locationNo,
          dataList: this.sampleBarcodeList,
          clientDesc: 'abs-pc',
        })
        .then(() => {
          this.$message.success(this.$l('INDEX.tips_set_ok') || '设置成功！')
          this.$emit('close')
        })
    },
    calculateClassLevel() {
      const node = this.$refs.cascaderFunctionTreeRef.getCheckedNodes()
      if (node && node.length) {
        this.form.locationNo = node[0].data.locationNo
        this.form.level = node[0].data.level
      }
    },
    getSampleInfo() {
      if (
        this.form.sampleBarcode &&
        this.sampleBarcodeList.indexOf(this.form.sampleBarcode) == -1
      ) {
        this.$api
          .stockSampleLocationDetailSampleBarcodeApi({
            sampleBarcode: this.form.sampleBarcode,
          })
          .then((res) => {
            this.tableData = this.tableData.concat(res.body?.data || [])
            this.form.sampleBarcode = ''
          })
          .catch(() => {
            this.form.sampleBarcode = ''
          })
      } else {
        this.form.sampleBarcode = ''
      }
    },
    delRow(rowId) {
      this.tableData.splice(rowId, 1)
    },
  },
}
</script>
